import { ArgsProps } from 'antd/es/notification/interface';
import { create } from 'zustand/react';

type Theme = 'light' | 'dark';
type Nullable<T> = T | null;

interface UIStore {
  notification: Nullable<ArgsProps>;
  theme: Theme;

  openNotification(data: ArgsProps): void;

  setTheme(theme: Theme): void;
}

export const useUIStore = create<UIStore>((setState) => ({
  notification: null,
  theme: typeof window !== 'undefined' ? ((localStorage.getItem('theme') as Theme) ?? 'dark') : 'dark',

  openNotification(data) {
    setState({ notification: data });
  },

  setTheme(theme: Theme) {
    setState({ theme });
  },
}));
